module.exports = __webpack_public_path__ + "media/images/nabor-24-gymskolka-bf1a6e1f2ee8288654bb7290e4794f88.jpg";